import AlchemyScore from '../alchemy-score';
import IngredientsList from '../ingredients-list';
import Recipe from '../recipe';
import ProductInfo from './info';
import ProductSelect from './select';

export {
	ProductSelect,
};

const Product = ({
	product,
	ingredients,
	setIngredients,
	onAddCatalystToBasket,
	onAddSpecificMainToBasker,
	onAddAgentToBasket,
}) => {
	return (
		<div className="product">

			<h2 className='product__info--title'>
				{product.name}
				<img
					src={`./assets/items/${product.id}.gif`}
					alt={`${product.name}`}
					title={`${product.name}`}
				/>
			</h2>
			<div className="grid grid-sm-3">
				<ProductInfo
					product={product}
					onAddCatalystToBasket={onAddCatalystToBasket}
					onAddSpecificMainToBasker={onAddSpecificMainToBasker}
				/>
				<AlchemyScore ingredients={ingredients} product={product} />
				<IngredientsList ingredients={ingredients} />
			</div>
			<Recipe
				element={product.element}
				recipe={product.recipe}
				ingredients={ingredients}
				setIngredients={setIngredients}
				product={product}
				onAddAgentToBasket={onAddAgentToBasket}
			/>
		</div>
	);
};

export default Product;
